export enum Action {
  SUBMIT_FINAL = 'SUBMIT_FINAL',
  REVIEW = 'REVIEW',
  REJECT = 'REJECT',
  RETURN = 'RETURN',
}
